export default __webpack_public_path__ + "static/media/portrait.ca37a071.png";